import { useEffect } from 'react';
import { useTheme } from '@/hooks/useTheme.ts';

export type InterfaceTheme = 'classic' | 'modern';

/**
 * ThemeInitializer - component for initializing theme on application load.
 * Performs side effects to apply theme classes to document.body.
 * Does not render UI.
 */
export function ThemeInitializer() {
  const { mounted } = useTheme();

  useEffect(() => {
    if (!mounted) return;

    // Initialize interface theme from localStorage
    if (typeof window !== 'undefined') {
      const savedInterfaceTheme = localStorage.getItem(
        'interface-theme'
      ) as InterfaceTheme | null;
      if (savedInterfaceTheme) {
        document.body.classList.remove('theme-classic', 'theme-modern');
        document.body.classList.add(`theme-${savedInterfaceTheme}`);
      } else {
        // Set default theme
        document.body.classList.remove('theme-classic', 'theme-modern');
        document.body.classList.add('theme-classic');
      }
    }
  }, [mounted]);

  return null;
}
